import { useCallback } from 'react';

import useGlobalModals from '~/components/GlobalModals/hooks/useGlobalModals';
import type { NectarPageBlock } from '~/utils/nectarPageBlock';
import { NECTAR_PAGE_BLOCK_GET_PARAM_NAME } from '~/utils/nectarTrackingFields';

/**
 * Opens the channel upgrade modal for a channel, from whichever gate the member clicked.
 * The intent travels through the URL, so `useChannelUpgradeGate` decides whether it opens.
 */
export const useOpenChannelUpgradeModal = () => {
  const { handleOpenModal } = useGlobalModals();

  return useCallback(
    (spaceId: string, pageBlock: NectarPageBlock) => {
      handleOpenModal(
        'community_channel_upgrade',
        { preventScrollReset: true },
        { space_id: spaceId, [NECTAR_PAGE_BLOCK_GET_PARAM_NAME]: pageBlock },
      );
    },
    [handleOpenModal],
  );
};
